import type { PrefetchApiConfigType } from '../index'

export function createTaskConfigList(
  globalConfig?: PrefetchApiConfigType,
  pageConfig?: PrefetchApiConfigType
): PrefetchApiConfigType {
  const result: { [propKey: string]: any } = {}
  // 外部已实现 propKey 冲突的检查
  const allConfig: PrefetchApiConfigType = { ...globalConfig, ...pageConfig }
  Object.keys(allConfig).forEach((propKey) => {
    const config = allConfig[propKey]
    result[propKey] = {
      ...config,
      category: pageConfig && propKey in pageConfig ? 'page' : 'global',
    }
  })
  return result
}
